/**
 =========================================================
 * Material Dashboard 2 PRO React - v2.1.0
 =========================================================

 * Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
 * Copyright 2022 Creative Tim (https://www.creative-tim.com)

 Coded by www.creative-tim.com

 =========================================================

 * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
 */

import * as Yup from "yup";
import checkout from "./form";

const {
    formField: { first_name, last_name, gender, birth_day, email, phone, avatar },
} = checkout;

const phoneRegExp = /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;

const validations = Yup.object().shape({
    [first_name.name]: Yup.string().required(first_name.errorMsg),
    [last_name.name]: Yup.string().required(last_name.errorMsg),
    [gender.name]: Yup.string().required(gender.errorMsg),
    // [birth_day.name]: Yup.string().required(birth_day.errorMsg),
    [email.name]: Yup.string().email().required(email.errorMsg),
    [avatar.name]: Yup.mixed().required('File is required'),
    // [phone.name]: Yup.string().required(phone.errorMsg),
  });

export default validations;
